export class Newsletter {
  id: number;
  date: string;
  title: string;
  content: string;
  thumbnail: string;
  know_more_link: string;
}